import { COLORS } from '@avalara/bat-apps-shared/constants';
import { t } from '@avalara/bat-apps-shared/i18n';
import { SIcon } from '@avalara/skylab-sdk/react';

import styled from 'styled-components';

import { informationYouNeedBulletContent, saveTimeText } from '../constants';

const InfoWrapper = styled.div`
  align-items: center;
  background-color: ${COLORS.lightestGray};
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0px auto;
  padding-bottom: 30px;

  div {
    width: 45%;
  }

  s-icon {
    color: ${COLORS.darkBlue};
  }

  p {
    font-size: 18px;
    line-height: 24px;
  }
`;

const InformationYouNeed = () => (
  <InfoWrapper>
    <h2 data-ref='buy.risk-assessment.thankyou.info-header' className='alt pad-top-lg pad-bottom-sm text-center'>
      {saveTimeText}
    </h2>
    <div>
      {informationYouNeedBulletContent.map((bulletText, i) => (
        <p
          key={bulletText}
          data-ref={`buy.risk-assessment.thankyou.info-content-${i}`}
          className={informationYouNeedBulletContent.length > 1 ? 'pad-all-xs' : 'pad-all-xs text-center'}
        >
          {informationYouNeedBulletContent.length > 1 && (
            <SIcon
              name='check'
              className='pad-right-xs'
              aria-label={t('client.accessibility.check-mark-for-bulleted-text')}
            />
          )}
          {bulletText}
        </p>
      ))}
    </div>
  </InfoWrapper>
);

export default InformationYouNeed;
